module.exports = __webpack_public_path__ + "img/inbox-in.28a9593f.svg";